import { render, staticRenderFns } from "./TexInputComponent.vue?vue&type=template&id=2633ec31"
import script from "./TexInputComponent.vue?vue&type=script&lang=js"
export * from "./TexInputComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports